import { type ComponentProps, forwardRef } from 'react'

import { TertiaryButton } from '@enechain/ecloud-designsystem'

/** 正方形の一辺 = DS Button の md の高さ (40px)。 `ROW_ACTION_BUTTON_PX` (stickyActionColumn.ts) と揃える。 */
const SQUARE_ICON_BUTTON_SIZE = '40px'

type Props = Omit<
  ComponentProps<typeof TertiaryButton>,
  'size' | 'width' | 'height' | 'minWidth' | 'padding' | 'paddingX'
> & {
  /** アイコンだけで名前が見えないので必須。 */
  'aria-label': string
}

/**
 * アイコンだけのボタン。 40px の正方形の Tertiary (白い地・枠・角丸は文字の `TertiaryButton` と同じ) にする。
 * 表のセル内のボタンは全て DS の M サイズ (`size="md"` = 高さ 40px) に揃える (デザイナー判断 2026-10-30。
 * 旧 32px 規約の置き換え。 #12635)。 正方形の幅 40px は DS の md の `minWidth` と同じ。
 *
 * [design 差異] 旧 HTML プロトタイプと React mock の `.btn-square` は 32×32 (UI 辞書 components/table.md
 * 「右端固定操作列のアイコンのみボタン」)。 dev は 2026-10-30 のユーザー指示「dev > table の TD 内のボタンの
 * height は全て 40px (m サイズ) 準拠」で 40×40 にする。 UI 辞書は同じ table.md の「表のセル内のボタンの高さ
 * (dev、2026-10-30)」 に記録 (design update #12667 で main に入る)。 `lint:table-button-size` が守る。
 *
 * DS `IconButton` の `outline` は地が透明で、 表の縞・行の hover の色がボタンに透けるため使わない。
 * `disabled` は DS のラベル付きボタンと同じく `aria-disabled` で表され、 押せない間も focus を受ける。
 * DS `Tooltip` の trigger に置けるよう ref を通す。
 */
export const SquareIconButton = forwardRef<HTMLButtonElement, Props>(
  function SquareIconButton(props, ref) {
    return (
      <TertiaryButton
        ref={ref}
        {...props}
        width={SQUARE_ICON_BUTTON_SIZE}
        minWidth={SQUARE_ICON_BUTTON_SIZE}
        paddingX={0}
        size="md"
      />
    )
  },
)
